import { AnimatePresence, motion } from "framer-motion";
import styled, { css, keyframes } from "styled-components";

import { useThrottledLoadingState } from "../../../hooks";
import { Icon } from "../Icon";

type PageTitleProps = {
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
};

export function PageTitle({ children, loading, ...props }: PageTitleProps) {
  const isLoadingThrottled = useThrottledLoadingState(!!loading, 1500);

  return (
    <PageTitleContainer {...props}>
      {children}
      <AnimatePresence>
        {isLoadingThrottled && (
          <LoadingIconContainer>
            <LoadingIcon />
          </LoadingIconContainer>
        )}
      </AnimatePresence>
    </PageTitleContainer>
  );
}

const iconAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const PageTitleContainer = styled.h2`
  grid-area: title;
  font: ${({ theme }) => theme.fontStudioHeadingsH2ShortHand};
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
`;

export const PageSubTitle = styled.h3(
  ({ theme }) => css`
    grid-area: subtitle;
    color: ${theme.colorBase500};
    font: ${theme.fontStudioBodyCopyRegularShortHand};
    letter-spacing: ${theme.fontStudioBodyCopyRegularLetterSpacing};
    margin: 0;
  `
);

const LoadingIconContainer = styled(motion.span).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
})`
  display: inline-flex;
  margin-bottom: 6px;
`;

const LoadingIcon = styled(Icon).attrs({ type: "arrow_clockwise" })`
  animation: ${iconAnimation} 1s infinite;
  margin-left: 0.25em;
`;
